// tslint:disable:max-line-length

import React from 'react';

export const ObjectInspection = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C7.2,0,6.5,0.7,6.5,1.5V2h-1c-0.6,0-1,0.5-1,1v1h7V3c0-0.5-0.4-1-1-1h-1V1.5C9.5,0.7,8.8,0,8,0z M8,1 c0.3,0,0.5,0.2,0.5,0.5V2h-1V1.5C7.5,1.2,7.7,1,8,1z M1.8,3C1.6,3,1.5,3.1,1.5,3.2v12.5c0,0.1,0.1,0.2,0.2,0.2h12.5 c0.1,0,0.2-0.1,0.2-0.2V3.2c0-0.1-0.1-0.2-0.2-0.2h-1.8v2h-9V3H1.8z" />
    </svg>
  );
};
